import React from 'react';
import moment from 'moment';
import { DATE_FORMAT } from 'constants/app-constants';
import DispatchReportListFunctional from './components/dispatch-report-list-functional';
import './dispatch-report.scss';

export const dispatchColumn = [
	{
		title: 'Load No',
		dataIndex: 'loadNo',
		key: 'loadNo',
		width: '8%',
		sorter: (a, b) => a?.loadNo - b?.loadNo,
		render: (value) => <div>{value?.toString()}</div>,
	},
	{
		title: 'Load Date',
		dataIndex: 'loadDate',
		key: 'loadDate',
		width: '10%',
		sorter: (a, b) => new Date(a.loadDate) - new Date(b.loadDate),
		render: (value) => <div>{moment(value).format(DATE_FORMAT.DD_MM_YYYY)}</div>,
	},
	{
		title: 'Vehicle No',
		dataIndex: 'vehicleNo',
		key: 'vehicleNo',
		width: '12%',
		sorter: (a, b) => a?.vehicleNo?.localeCompare(b?.vehicleNo),
		render: (value) => <div>{value || ''}</div>,
	},
	{
		title: 'LR Number',
		dataIndex: 'lrNumber',
		key: 'lrNumber',
		width: '10%',
		sorter: (a, b) => a?.lrNumber - b?.lrNumber,
		render: (value) => <div>{value?.toString()}</div>,
	},
	{
		title: 'Part Number',
		dataIndex: 'partNumber',
		key: 'partNumber',
		width: '12%',
		sorter: (a, b) => a?.partNumber?.localeCompare(b?.partNumber),
		render: (value) => <div>{value || ''}</div>,
	},
	{
		title: 'SAP Number',
		dataIndex: 'sapNumber',
		key: 'sapNumber',
		width: '12%',
		sorter: (a, b) => a?.sapNumber?.localeCompare(b?.sapNumber),
		render: (value) => <div>{value || ''}</div>,
	},
	{
		title: 'Invoice No#',
		dataIndex: 'invoiceNumber',
		key: 'invoiceNumber',
		width: '10%',
		sorter: (a, b) => a?.invoiceNumber?.localeCompare(b?.invoiceNumber),
		render: (value) => <div>{value || ''}</div>,
	},
	{
		title: 'Invoice Qty',
		dataIndex: 'invoiceQty',
		key: 'invoiceQty',
		width: '10%',
		align: 'right',
		sorter: (a, b) => a?.invoiceQty - b?.invoiceQty,
		render: (value) => <div>{parseFloat(value || 0).toFixed(2)}</div>,
	},
	{
		title: 'Invoice Weight',
		dataIndex: 'invoiceWeight',
		key: 'invoiceWeight',
		width: '10%',
		align: 'right',
		sorter: (a, b) => a?.invoiceWeight - b?.invoiceWeight,
		render: (value) => <div>{parseFloat(value || 0).toFixed(2)}</div>,
	},
	{
		title: 'Tax Value',
		dataIndex: 'taxValue',
		key: 'taxValue',
		width: '10%',
		align: 'right',
		sorter: (a, b) => a?.taxValue - b?.taxValue,
		render: (value) => <div>{parseFloat(value || 0).toFixed(2)}</div>,
	},
	{
		title: 'Total Value',
		dataIndex: 'totalValue',
		key: 'totalValue',
		width: '10%',
		align: 'right',
		sorter: (a, b) => a?.totalValue - b?.totalValue,
		render: (value) => <div>{parseFloat(value || 0).toFixed(2)}</div>,
	},
	{
		title: 'Status',
		dataIndex: 'status',
		key: 'status',
		width: '10%',
		sorter: (a, b) => a?.status?.localeCompare(b?.status),
		render: (value) => <div>{value || ''}</div>,
	},
	{
		title: 'Dispatch Date',
		dataIndex: 'dispatchDate',
		key: 'dispatchDate',
		width: '10%',
		sorter: (a, b) => new Date(a.dispatchDate) - new Date(b.dispatchDate),
		render: (value) => <div>{moment(value).format(DATE_FORMAT.DD_MM_YYYY)}</div>,
	},
];

const DispatchReportList = () => {
	return <DispatchReportListFunctional />;
};

export default DispatchReportList;
